export default {
	namespaced: true,
	state: {
		settings: {
			widgets: {},
            trading: {},
            header: {
                minimaze:true
            },
            leftNavigator:true,
            navigator: [
                {
                    name: "Стрим",
                    component: "stream",
                    statusActive: true
                },
                {
                name: "Доходность",
                component: "income-widgets",
                statusActive: true
                },
                {
                name: "Открытые позиции",
                component: "open-position",
                statusActive: true
                },
                {
                name: "Котировки",
                component: "sig-quote-widget",
                statusActive: true
                },
                {
                name: "Новости",
                component: "news",
                statusActive: false
                },
                /*{
                name: "Доход Неделя / Месяц",
                component: "chart-widget",
                statusActive: false
                }*/
                {
                name: "Статистика",
                component: "summary-table",
                statusActive: true
                }
            ],
            fullScreen: {
                left:true,
                right:true,
                bottom:true,
            },
            autoSlider:true,
		}
	},
	mutations: {
		setSettings(state, data) {
			state.settings = data;
        },
        
		setWidget(state, data) {
			//Vue.set(state.settings[data.id], data);
			state.settings.widgets[data.id] = data;
        },
        setSettingsHeaderMinimaze(state, data) {
            state.settings.header.minimaze = data;
            //window.localStorage.removeItem('settingsDesktop');
            window.localStorage['settingsDesktop'] = JSON.stringify(state.settings);
        },
        setSettingsHeaderAuto(state, data) {
            state.settings.autoSlider = data;
            window.localStorage['settingsDesktop'] = JSON.stringify(state.settings);
        },
        setSettingsNavigatorItem(state, data) {
            state.settings.navigator = data;
            window.localStorage['settingsDesktop'] = JSON.stringify(state.settings);
        },
        setSettingsNavigatorShowItem(state, data) {
            for(let i = 0; i < state.settings.navigator.length; i++) {
                state.settings.navigator[data.index].show = data.e;
            }
        },
        setNavigator(state) {
            state.leftNavigator = !state.leftNavigator;
        }
	},
	getters: {
		getSettings(state) {
			return state.settings;
        },
        getHeader(state) {
            return state.settings.header;
        },
		getWidget(state) {
			return (id) => { return state.settings.widgets[id]; }
        },
        getStatusNavigator(state) {
            return state.leftNavigator;
        }
	},
	actions: {
		applyWidgetSettings(state, data) {
			state.commit('setWidget', data);
			saveSettings(state.getters['getSettings']);
        },
        changeLeftNavigatorStatus(store) {
            store.commit('setNavigator')
        },
        setSettingsFromStorage(store, payload) {
            store.commit('setSettings', payload) 
        },
        saveSettingsHeaderMinimaze(store, status) {
            store.commit('setSettingsHeaderMinimaze', status)
        },
        saveSettingsHeaderAuto(store, status) {
            store.commit('setSettingsHeaderAuto', status)
        },
        saveSettings (store,payload) {
            window.localStorage['settingsDesktop'] = JSON.stringify(payload);
            store.commit('setSettings', payload) 
        },
        saveSettingsNavigatorItem (store,payload) {
            store.commit('setSettingsNavigatorItem', payload)
        },
        saveSettingsNavigatorShowItem (store,payload) {
            store.commit('setSettingsNavigatorShowItem', payload)
        },
        applyHeader(store,  data) {
            store.commit('setHeader',data)
        }
	}
}

function saveSettings(settings) {
	let json = JSON.stringify(settings);
}